import * as React from "react";

// Explicitly list the headers we're using to avoid passing the entire request header
export type RequestHeadersContextProps =
  | ({
      "user-agent"?: string;
    } & Record<never, string>)
  | null;

export const defaultRequestHeadersContextProps = null;

export const RequestHeadersContext =
  React.createContext<RequestHeadersContextProps>(
    defaultRequestHeadersContextProps,
  );
